// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
console.log(process.env.API_KEY)
const firebaseConfig = {
    apiKey: "AIzaSyB7WMOBUYkLmsPLDDCbqUp78RCg4lBGHgU",
    authDomain: "hemopets-c2ed5.firebaseapp.com",
    projectId: "hemopets-c2ed5",
    storageBucket: "hemopets-c2ed5.appspot.com",
    messagingSenderId: "1065335750895",
    appId: "1:1065335750895:web:ebd88b349a4ab67a07db1a",
    measurementId: "G-K2CPQKYZW7",
    databaseURL: "https://hemopets-c2ed5-default-rtdb.firebaseio.com/"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const database = getDatabase(app);